import {
  
    SET_SUBMISSION_REVIEW_REFERE,

} from "constants/ActionTypes";

const INIT_STATE = {
    submission: null,
    submissionReview:null,
    isReview: false,
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SET_SUBMISSION_REVIEW_REFERE: {
            return {
                ...state,
                submission: action.payload.submission,
                submissionReview : action.payload.submissionReview,
                isReview: action.payload.isReview
            }
        }
        default:
            return state;
    }
}
